module.exports = __webpack_public_path__ + "img/delay.eba884b.svg";